import { createSlice } from "@reduxjs/toolkit";

import { fetchBooksForSomDb } from "../../pages/Som/SomDb/services/fetchBooksForSomDb";
import { fetchFilterTypes, fetchXmlShemas } from "./services";

export const booksSlice = createSlice({
	name: "books",
	initialState: {
		priceZones: [],
		cities: [],
		nrspVers: [],
		units: [],
		expensesTypes: [],
		matchTypes: [],
		charsBook: [],
		charsEnumBook: {},
		somStatus: [],
		somClassifier: [],
		ssrCalcsTypes: [],
		ssrCalcsBook: [],
		northTerrs: [
			{ id: 1, name: "Обычная" },
			{ id: 2, name: "МПРКС" },
			{ id: 3, name: "РКС" },
		],
		projectObjTypes: [
			{ id: 1, name: "Гражданский" },
			{ id: 2, name: "Производственный" },
			{ id: 3, name: "Линейный" },
		],
		filterTypes: [],
		xmlShemas: [],
		strMatchTypes: [
			{ id: 10, name: "=", title: "равно" },
			{ id: 11, name: "~", title: "содержит" },
		],
		projectWorkTypes: [
			{ id: 1, name: "Строительство" },
			{ id: 2, name: "Капитальный ремонт" },
			{ id: 3, name: "Реконструкция" },
		],
	},
	reducers: {
		setPriceZones: (state, { payload }) => {
			state.priceZones = payload;
		},
		setCities: (state, { payload }) => {
			state.cities = payload;
		},
		setUnits: (state, { payload }) => {
			state.units = payload;
		},
		setNrspVers: (state, { payload }) => {
			state.nrspVers = payload;
		},
		setExpensesTypes: (state, { payload }) => {
			state.expensesTypes = payload;
		},
		setMatchTypes: (state, { payload }) => {
			state.matchTypes = payload;
		},
		setCharsBook: (state, { payload }) => {
			state.charsBook = payload;
		},
		setCharsEnumBook: (state, { payload }) => {
			state.charsEnumBook = payload;
		},
		setSomStatus: (state, { payload }) => {
			state.somStatus = payload;
		},
		setSomClassifier: (state, { payload }) => {
			state.somClassifier = payload;
		},
		setSsrCalcTypes: (state, { payload }) => {
			state.ssrCalcsTypes = payload;
		},
		setSsrCalcBook: (state, { payload }) => {
			state.ssrCalcsBook = payload;
		},
		setFilterTypes: (state, { payload }) => {
			state.filterTypes = payload;
		},
		setXmlShemas: (state, { payload }) => {
			state.xmlShemas = payload;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchBooksForSomDb.fulfilled, (state, { payload }) => {
			state.charsBook = payload.chars;
			state.somClassifier = payload.classifiers;
			state.matchTypes = payload.match_types;
			state.charsEnumBook = payload.chars_enum;
			state.somStatus = payload.status;
		});

		builder.addCase(fetchFilterTypes.fulfilled, (state, { payload }) => {
			state.filterTypes = payload;
		});
		builder.addCase(fetchXmlShemas.fulfilled, (state, { payload }) => {
			state.xmlShemas = payload;
		});
	},
});

export const {
	setPriceZones,
	setCities,
	setUnits,
	setExpensesTypes,
	setMatchTypes,
	setCharsBook,
	setCharsEnumBook,
	setSomStatus,
	setSomClassifier,
	setSsrCalcTypes,
	setSsrCalcBook,
	setNrspVers,
	setXmlShemas,
} = booksSlice.actions;
export default booksSlice.reducer;
